<ng-container *ngFor="let breadcrumb of breadcrumbs$ | async; last as isLastBreadcrumb">
    <ng-container [ngSwitch]="getBreadcrumbType | thunk : breadcrumb : isLastBreadcrumb">
        <a *ngSwitchCase="BreadcrumbType.Home" [routerLink]="breadcrumb.url" class="breadcrumbs-item">
            <cm-icon name="bread-home" class="home-icon" #icon></cm-icon>
        </a>

        <a *ngSwitchCase="BreadcrumbType.Simple" [routerLink]="breadcrumb.url" class="breadcrumbs-item">
            {{breadcrumb.label}}
        </a>

        <span *ngSwitchCase="BreadcrumbType.Current" class="breadcrumbs-item last">{{breadcrumb.label}}</span>
    </ng-container>
</ng-container>
